import { SearchForm } from "components/search/search";
import { useRef } from "react";
import { EmptyState } from "../EmptyState";
import { PersonSearch } from "@mui/icons-material";
import { filterList, useListFilter } from "hooks/useListFilter";
import { sortByName } from "utils/sort";
import { Box, List, Typography } from "@mui/material";
import { T } from "components/util/t";
import { useGetAthletes } from "./useGetAthletes";

const prepareForComparison = v => v.trim().toLowerCase();
const matchItemExact = (searchString, value) => prepareForComparison(value) === prepareForComparison(searchString);
const matchItem = (athlete, searchRegex, index, searchString) => athlete.name.match(searchRegex);

export const AthletesListSearch = ({
    placeholder,
    searchFormClassName,
    newItems = {},
    renderItem,
    canCreateItem,
    query,
}) => {
    const { items, search, loading, totalCount, resultsPerPage } = useGetAthletes(query);
    const { searchString, onSearch, filteredList } = useListFilter(items, matchItem, !loading, true);
    const inputRef = useRef();

    const handleOnChange = v => {
        onSearch(v);
        search(v);
    };

    const trimmedSearchString = searchString.trim();

    return (
        <>
            <SearchForm
                inputRef={inputRef}
                onChange={handleOnChange}
                search={searchString}
                placeholder={placeholder}
                className={searchFormClassName}
                autoComplete="off"
                loading={loading}
                name="search"
                autoFocus
            />

            {!filteredList.length && !searchString && Object.keys(newItems).length === 0 &&
                <EmptyState icon={<PersonSearch fontSize="large" />} text="Start typing a profile name to search for existing profiles or create a new one."/>
            }

            <Box overflow="auto">
                <List disablePadding>
                    {[...filterList(Object.values(newItems).sort(sortByName), searchString, matchItem, true), ...filteredList].map(item => (
                        <li key={item.id}>
                            {renderItem(item)}
                        </li>
                    ))}
                    {canCreateItem && trimmedSearchString && !newItems[trimmedSearchString] && !loading && !filteredList.some(item => matchItemExact(trimmedSearchString, item.name)) && renderItem({ name: trimmedSearchString, id: trimmedSearchString, isNew: true })}
                </List>

                {!loading && totalCount - filteredList.length > 0 && (
                    <Typography color="text.secondary" marginTop={2}>
                        <T x={resultsPerPage}>showing_x_results_per_page</T>
                    </Typography>
                )}
            </Box>
        </>
    );
};
